namespace GeniuzPOS.Inventory {
    export class IcStockApproveDisassembleColumns {
        static columnsKey = 'Inventory.IcStockApproveDisassemble';
    }
}
